import { render } from "./ThothButton.vue?vue&type=template&id=28791aa6&scoped=true&ts=true"
import script from "./ThothButton.vue?vue&type=script&lang=ts"
export * from "./ThothButton.vue?vue&type=script&lang=ts"

import "./ThothButton.vue?vue&type=style&index=0&id=28791aa6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28791aa6"]])

export default __exports__